import { UserRole } from './user-role.model';

export const USER_ROLE_TRANSLATION_KEYS: Record<UserRole, string> = {
    [UserRole.SystemAdministrator]: 'USER_ROLES.SYSTEM_ADMINISTRATOR',
    [UserRole.PortalAdministrator]: 'USER_ROLES.PORTAL_ADMINISTRATOR',
    [UserRole.PortalSuperUser]: 'USER_ROLES.PORTAL_SUPER_USER',
    [UserRole.PortalUser]: 'USER_ROLES.PORTAL_USER',
};
